export default __webpack_public_path__ + "static/design-carousel-page-0b56559a4cf60f619245bd3c4883bd3d.png";